import axios from 'axios/dist/axios'
import { store } from '@/store/index'
import AgReportError from '@/components/Modal/ReportError'
import dialog from './dialog'
import env from './env'
import user from './user'


function getApi () {
  const api = axios.create()

  api.interceptors.request.use(async config => {
    config.headers = config.headers || {}
  
    config.headers['Client-Key'] = process.env.VUE_APP_CLIENT_KEY
    config.headers['Frontend-Name'] = env.appName
    config.headers['Frontend-Version'] = env.appVersion
    config.headers['Frontend-Platform'] = env.platform
  
    if (!config.headers['Authorization'] && store.state.user.token) {
      if (config.userCheck !== false && !await user.check()) {
        console.log('CHECK')

        throw new axios.Cancel('Operation canceled by the user.')
      }

      config.headers['Authorization'] = 'Bearer ' + store.state.user.token
    }
  
    if (!env.isWeb) {
      config.headers['User-Agent'] = env.system.os + '/' + env.system.osVersion
    }
  
    config.baseURL = config.baseURL || getEndpoint()

    //console.log('REQ')
    return config
  }, error => {
    console.log('Do something with request error')
    return Promise.reject(error)
  })
  
  api.interceptors.response.use(response => {
    return response
  }, error => {
    error.handler = () => {
      return errorHandler(error)
    }
  
    return Promise.reject(error)
  })

  return api
}

function statusValidation (list) {
  return status => (status >= 200 && status < 300) || list.indexOf(status) >= 0
}

function responseOk (response) {
  return response.status >= 200 && response.status < 300
}

function getEndpoint (mode) {
  let path = ''

  mode = mode || store.state.apiMode
  
  switch (mode) {
    case 'loc':
      return 'http://localhost/' + path

    case 'dev':
      return process.env.VUE_APP_API_ENDPOINT_DEV + path

    case 'stg':
      return process.env.VUE_APP_API_ENDPOINT_STG + path

    default:
      return process.env.VUE_APP_API_ENDPOINT_PRD + path
  }
}

function errorHandler (error) {
  if (error.response && error.response.status) {
    dialog.component(AgReportError, {
      type: 'API-Error',
      message: error.message,
      details: error
    })
  } else {
    dialog.component(AgReportError, {
      type: 'Server-Error',
      message: 'Endpoint not reachable',
      details: {
        url: getEndpoint()
      }
    })
  }

  return 'Vorgang konnte nicht ausgeführt werden.'
}

const api = getApi()

export {
  api,
  getApi,
  statusValidation,
  responseOk,
  getEndpoint,
  errorHandler
}
